import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { useSelectableProductAccounts } from '@features/products/hooks/useSelectableProductAccounts'
import { useGetVatRates } from '@features/vatRates/hooks/useGetVatRates'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { APIError } from '../../../../../utils'
import { ImportProductsResult } from '../types'
import { importProductsFromCsv } from '../utils/importProductsFromCsv'

interface UseImportProductsProps {
  onError?: (error: APIError) => void
  onSuccess?: (data: ImportProductsResult) => void
}

export const useImportProducts = ({ onError, onSuccess }: UseImportProductsProps = {}) => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()

  const isFrenchOrganization = organization?.countryId === 'FR'

  const { vatRates, isLoading: isLoadingVatRates } = useGetVatRates()
  const { accounts, isLoading: isLoadingAccounts } = useSelectableProductAccounts({ enabled: isFrenchOrganization })

  const {
    mutate: importProducts,
    isLoading: isImporting,
    reset,
  } = useMutation<ImportProductsResult, APIError, File>(
    (file: File) => importProductsFromCsv(file, t, vatRates, accounts),
    {
      onSuccess,
      onError,
    },
  )

  return { importProducts, isImporting, isLoadingImportData: isLoadingVatRates || isLoadingAccounts, reset }
}
